import {FETCH_ALL_AXIS, LOADING_AXIS, FETCH_ALL_AXIS_FAIL, CLEAR_AXIS} from "../actionTypes";

const initialState = {
    axis:[],
    message:"",
    status:0,
    isLoading: true
}

const axisReducer = (state = initialState, action) => {
    switch (action.type){
        case FETCH_ALL_AXIS:
            return {
                ...state,
                axis:action.payload.axis,
                status: action.payload.status,
                message: action.payload.message,
                isLoading: false
            };
        case LOADING_AXIS:
            return{
                ...state,
                isLoading:true,
            }
        case FETCH_ALL_AXIS_FAIL:
            return {
                ...state,
                message:action.payload.message,
                status: action.payload.status,
            }
        case CLEAR_AXIS:
            return initialState
        default:
            return {
                ...state
            }
    }
}

export default axisReducer;